__turbopack_context__.v({
  "bannerImg": "upload-asset-modal-module__LFrjEW__bannerImg",
  "bottomContent": "upload-asset-modal-module__LFrjEW__bottomContent",
  "collection": "upload-asset-modal-module__LFrjEW__collection",
  "container": "upload-asset-modal-module__LFrjEW__container",
  "creatorLink": "upload-asset-modal-module__LFrjEW__creatorLink",
  "editDropdownWrapper": "upload-asset-modal-module__LFrjEW__editDropdownWrapper",
  "iconSearch": "upload-asset-modal-module__LFrjEW__iconSearch",
  "image": "upload-asset-modal-module__LFrjEW__image",
  "imageContainer": "upload-asset-modal-module__LFrjEW__imageContainer",
  "infoCard": "upload-asset-modal-module__LFrjEW__infoCard",
  "middleContent": "upload-asset-modal-module__LFrjEW__middleContent",
  "name": "upload-asset-modal-module__LFrjEW__name",
  "ownerActions": "upload-asset-modal-module__LFrjEW__ownerActions",
  "pagination": "upload-asset-modal-module__LFrjEW__pagination",
  "priceInput": "upload-asset-modal-module__LFrjEW__priceInput",
  "requisites": "upload-asset-modal-module__LFrjEW__requisites",
  "topContent": "upload-asset-modal-module__LFrjEW__topContent",
  "topContentBG": "upload-asset-modal-module__LFrjEW__topContentBG",
});
